module.exports = __webpack_public_path__ + "static/cbre-bepaalt-risico-klimaatschade-vastgoed-002bfc99c5807b4333552987ac07cd6c.jpg";